import React, { useEffect, useState } from 'react';
import CustomDatePickerV2 from 'views/pages/manage/common/commonComponents/CustomDatePicker-V2';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import {ReactComponent as CloseIcon} from 'assets/img/svg/CrossIcon.svg';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import "./style.scss";

const ReminderDialog = ({
  open,
  title = 'Reminder & Remarks',
  initialRemarks = '',
  initialReminderDate = '',
  onClose = () => {},
  onSave = () => {},
  userPermissions
}) => {
  const [remarks, setRemarks] = useState(initialRemarks || '');
  const [reminderDate, setReminderDate] = useState(initialReminderDate || '');

  useEffect(() => {
    setRemarks(initialRemarks || '');
    setReminderDate(initialReminderDate || '');
  }, [initialRemarks, initialReminderDate, open]);

  const handleClose = () => {
    onClose();
  };

  const handleSave = () => {
    debugger
    onSave({ remarks, reminderDate });
  };
  const isRightsToEdit = (userPermissions || []).includes('C') || (userPermissions || []).includes('U');
  return (
    <Dialog open={open} onClose={handleClose} PaperProps={{ sx: { maxWidth: "unset", borderRadius: "12px" } }}>
      <div className="reminder-popup">
      <div className='d-flex justify-content-betwen align-items-center'>
        <div className='large-text color-black'>{title}</div>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </div>
      <div >
        <div>
          <div style={{ marginBottom: 8 }}>Remarks</div>
          <textarea
            placeholder="Add remarks..."
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            style={{ width: '100%', minHeight: 96, padding: 8, borderRadius: 4, border: '1px solid rgba(0,0,0,0.23)' }}
            disabled={!isRightsToEdit}
          />
        </div>
        <div style={{ marginTop: 16 }}>
          <CustomDatePickerV2
            label="Reminder Date"
            value={reminderDate}
            handler={(i, date) => setReminderDate(date)}
            placeHolder="Select date"
            disabled={!isRightsToEdit}
          />
        </div>
      </div>
      <div sx={{ justifyContent: 'flex-start' }}>
        <AButton
          variant="primary_filled"
          onClick={handleSave}
          disabled={!(remarks && remarks.trim() && reminderDate && isRightsToEdit)}
          className='btn-left-0 '
        >
          Save
        </AButton>
      </div>
      </div>
    </Dialog>
  );
};

export default ReminderDialog;
